import "./home.css";
import svg1 from "./svg1.svg";
import Carousel from "react-material-ui-carousel";
import Pexels1 from "../media/pexels1.jpg";
import img1 from "./img/img1.PNG";
import img2 from "./img/img2.PNG";
import popular from "./img/popular.png";
import worldmap from "./img/worldmap.png";
import Header from "./header";
import Footer from "./footer";
import { useRef, useState, useEffect } from "react";
import useWindowDimensions from "../Hook/useWindowDimensions";
import logo from "../media/logo.png";
import { Helmet } from "react-helmet-async";
import MultipleRows from "./slider";

const Home = () => {
  const [showopt, setShowopt] = useState(true);
  const [optmobile, setoptmobile] = useState(false);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (width <= 600) {
      setShowopt(false);
    } else {
      setShowopt(true);
    }
  });

  const handlehref = () => {
    window.location.href = "/";
  };

  const listimg = [img2, img1, img2];
  const anArrayOfNumbers = [
 
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/aca5332be1d870a77e5f714a7e9fb552_cleanup_clipdrop-enhance-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/510d2f0dfe8732823ceb600f572e9dba-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/cac49af920da9b0e9e87dcf4a8095acb-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/3ef891369aae362940da366a95438869_clipdrop-enhance-1.webp",

   "https://allaccessiptvstore.com/wp-content/uploads/2023/06/efc10d_c4763bc9523c4fc89ba4e9f22e5ce52d_mv2.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/06/efc10d_58769540c3af46e4b1b8373d25053dce_mv2.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/06/efc10d_cf5918f2dcf64cf39fcefe135495cc43_mv2.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/06/efc10d_d0631c9b9c3f4be9bd6caef12c4d0694_mv2.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/06/efc10d_e83995fe1b33435a982de93f05c82c29_mv2.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/06/efc10d_82f6ea18c2494be98c46c59b9e55cf71_mv2.webp",

   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/wallpapersden.com_chris-evans-ghosted-movie-2023_3840x2160-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/1185592-jpg-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/1374092824.0-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/100233-eden-hazard-chelsea-soccer-4k-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/np_file_214944_clipdrop-enhance-2.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/wallpapersden.com_the-last-kingdom-seven-kings-must-die-2023_2048x1152-2-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/10915284-scaled-1-1-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/0x0_clipdrop-enhance-1.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/59795dac6f2557dd3d90b5855e4175ac-1.webp",

   "https://allaccessiptvstore.com/wp-content/uploads/2023/06/Sans-titre-19-150x150.webp",

   "https://allaccessiptvstore.com/wp-content/uploads/2023/08/Rugby_World_Cup_2023_logo.svg.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/06/poster_7sx-150x150.png",
  


   "https://allaccessiptvstore.com/wp-content/uploads/2023/07/5.jpeg.webp",
  
   "https://allaccessiptvstore.com/wp-content/uploads/2023/07/10.jpeg_clipdrop-enhance.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/07/zpccttuqmhihycpsrwnw2ecrbql_clipdrop-enhance.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/07/z3otxroz0ldalxn62ejpeqfxwnn_clipdrop-enhance.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/07/wzfwoilbc81pzb1nign2lazqwqk_clipdrop-enhance.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2023/07/vyyobggec0qhe3crasbcp9o2zdj_clipdrop-enhance.webp",
   "https://allaccessiptvstore.com/wp-content/uploads/2024/07/Multimedia-Tv-Podcast-Play-Service-Logo-145-%C3%97-60-px-1.webp",
];

 
const imgdd =[
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/11-150x150.webp",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/10-150x150.png",
"https://allaccessiptvstore.com/wp-content/uploads/2023/06/8-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/7-150x150.webp",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/6-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/4-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/1-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/5-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/3-6-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/14-150x150.webp",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/tlc-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/12-150x150.webp",
"https://allaccessiptvstore.com/wp-content/uploads/2023/06/13-150x150.webp",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/poster_7s-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/poster_7d-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/poster_7cv-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/poster_7-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/nbc-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/hbo-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/fox-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/bien-150x150.png",
  "https://allaccessiptvstore.com/wp-content/uploads/2023/06/wild-150x150.png",
]

  const myref = useRef(null);

  const [shownav, setshownav] = useState(false);

  const handleshow = () => {
    setshownav((current) => !current);
  };

  const scrolltosub = () => myref.current.scrollIntoView();

  return (
    <>
      <Helmet>
        <title>
          Best IPTV Subscription Service Provider at 9.99$ - IPTV-STORE
        </title>
        <meta
          name="description"
          content="Fast order delivery, Weekly updated, Fast zapping, Premium Quality. Support 7 Days A Week. Premium 4k Channels from more than 82 Countries. Fast Deliver once your Place order. Watch on All Devices. Safe & Secure payments. No More Expensive Cable."
        />
        <link rel="canonical" href="https://www.iptv-store.one/" />
      </Helmet>
      <header className="m-header">
        <div className="container">
          <a href="/">
            <img
              style={{ width: " 105px", height: "53px" }}
              className="lazyload"
              src={logo}
            />
          </a>

          {showopt && (
            <div className="m-header__right">
              <nav>
                <ul id="menu-top-menu" className="menu">
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/">Home</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a style={{ cursor: "pointer" }} onClick={scrolltosub}>
                      Subscription
                    </a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/Terms">Terms</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/refund">Refund Policy</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/FAQ">FAQ</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/About">About Us</a>
                  </li>
                </ul>
              </nav>
              <div className="m-header__right__cta">
                <a href="/Contactus" className="btn-yellow">
                  Contact us
                </a>
              </div>
            </div>
          )}

          {shownav && (
            <div className="m-header__right">
              <nav>
                <ul id="menu-top-menu" className="menu">
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/">Home</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a style={{ cursor: "pointer" }} onClick={scrolltosub}>
                      Subscription
                    </a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/Terms">Terms</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/refund">Refund Policy</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/FAQ">FAQ</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    {" "}
                    <a href="/About">About Us</a>
                  </li>
                </ul>
              </nav>
              <div className="m-header__right__cta">
                <a href="/Contactus" className="btn-yellow">
                  Contact us
                </a>
              </div>
            </div>
          )}

          <div className="hamburger-wrap">
            {shownav ? (
              <div className="hamburger">
                <a className="closei" onClick={handleshow}>
                  <i className="fa-solid fa-xmark"></i>
                </a>
              </div>
            ) : (
              <div className="hamburger">
                <a onClick={handleshow} className="main-nav-toggle">
                  <i>Menu</i>
                </a>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* <div className="headerdiv">
        <div className="logoheder">
          <img
            onClick={handlehref}
            src="https://go-iptv.store/img/new-img/GO%20IPTV%20Community%20checkout.svg"
          />
        </div>
      </div> */}

      <main id="m">
        <section className="hero-section">
          <div className="container">
            <div className="hero-wrap">
              <h1>IPTV-STORE, the most flexible TV Platform</h1>
              <p>
                IPTV-STORE gives you the opportunity to watch a lot of TV
                channels Live anywhere on any device with premium FHD, HD & SD
              </p>

              <div className="hero-wrap__cta">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={scrolltosub}
                  className="btn btn-blue"
                >
                  Request Free trial 24H
                </a>
                <a
                  href="/Contactus"
                  style={{ color: "white" }}
                  className="btn btn-outlined"
                >
                  Contact us
                </a>
              </div>
            </div>
          </div>
        </section>

        <div
          data-elementor-type="wp-page"
          data-elementor-id="1189"
          className="elementor elementor-1189"
          data-elementor-settings="[]"
        >
          <div className="elementor-section-wrap">
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-e13fd06 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
              data-id="e13fd06"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ecd7acc"
                  data-id="ecd7acc"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-8a32d50 elementor-widget elementor-widget-wp-widget-text"
                      data-id="8a32d50"
                      data-element_type="widget"
                      data-widget_type="wp-widget-text.default"
                    >
                      <div className="elementor-widget-container">
                        <section className="content-white top_companies home_companies">
                          <div className="title">
                            Trusted by successful companies
                          </div>

                          {/* ********************************************* */}

                          <MultipleRows images={anArrayOfNumbers}  type={"l"}  />
                          {/* <div className="containercar playcar">
                            {anArrayOfNumbers &&
                              anArrayOfNumbers.map((x) => (
                                <div className="cardcar"  >
                                  <img className="frdss" src={x} />
                                 
                                </div>
                              ))}

                              
                          </div> */}
                            <MultipleRows images={imgdd} type={"s"} />


                            <MultipleRows images={anArrayOfNumbers}  type={"b"}  />
                          {/* <div className="containercar playcar-reverse">
                            {imgdd &&
                              imgdd.map((x) => (
                                <div className="cardcarCircle">
                                  <img  className="inggcircle" src={x} />
                                  
                                </div>
                              ))}
                          </div>
                          <div className="containercar playcar-reverse"> */}
                            {/* {anArrayOfNumbers &&
                              anArrayOfNumbers.map((x) => (
                                <div className="cardcar">
                                  <img className="frdss" src={x} />
                                  
                                </div>
                              ))}
                          </div> */}
                    
                          {/* ********************************************* */}
                          {/* <Carousel
                            duration={5}
                            indicatorContainerProps={{
                              style: {
                              
                                position: "relative",
                              },
                            }}
                            autoPlay
                          >
                            {listimg &&
                              listimg.map((x) => (
                                <div className="container">
                                  <a href="#">
                                    <img className="lazyload" src={x} />
                                  </a>
                                </div>
                              ))}
                          </Carousel> */}

           
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-0c3e774 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
              data-id="0c3e774"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6cce22a"
                  data-id="6cce22a"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-e3f6f50 elementor-widget elementor-widget-wp-widget-text"
                      data-id="e3f6f50"
                      data-element_type="widget"
                      data-widget_type="wp-widget-text.default"
                    >
                      <div ref={myref} className="elementor-widget-container">
                        <section className="content-gray swipe_products">
                          <div className="container second-container">
                            <div className="swiper-container">
                              <div className="swiper-change">
                                <a href="/Checkout/1" className="swiper-slide">
                                  <div className="pricediv">
                                    <div className="titleprice">
                                      <h3> 1 Month </h3>
                                      <h3> 10$ </h3>
                                    </div>

                                    <div className="buttongetstar">
                                      <button> Get Started</button>
                                    </div>

                                    <div className="optPrice">
                                      <div
                                        style={{ marginTop: "38px" }}
                                        className="divco"
                                      >
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>
                                            {" "}
                                            +20,000 TV Channels, Movies & Series
                                          </p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div
                                          style={{ marginBottom: "-21px" }}
                                          className="imgverify"
                                        >
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div
                                          style={{ height: "50px" }}
                                          className="optproduct"
                                        >
                                          {" "}
                                          <p> + 40.000 VOD​</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>
                                            {" "}
                                            FHD, HD & SD Picture Quality
                                          </p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p> All Devices Supported</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>99.9% Server Uptime</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p> Support 24/7​</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>Daily Backups</p>{" "}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>

                                <a href="/Checkout/2" className="swiper-slide">
                                  <div className="pricediv">
                                    <div className="titleprice">
                                      <h3> 3 Month </h3>
                                      <h3> 20$ </h3>
                                    </div>

                                    <div className="buttongetstar">
                                      <button> Get Started</button>
                                    </div>

                                    <div className="optPrice">
                                      <div
                                        style={{ marginTop: "38px" }}
                                        className="divco"
                                      >
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>
                                            {" "}
                                            +20,000 TV Channels, Movies & Series
                                          </p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div
                                          style={{ marginBottom: "-21px" }}
                                          className="imgverify"
                                        >
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div
                                          style={{ height: "50px" }}
                                          className="optproduct"
                                        >
                                          {" "}
                                          <p> + 40.000 VOD​</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>
                                            {" "}
                                            FHD, HD & SD Picture Quality
                                          </p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p> All Devices Supported</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>99.9% Server Uptime</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p> Support 24/7​</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>Daily Backups</p>{" "}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <a href="/Checkout/3" className="swiper-slide">
                                  <div className="populardiv">
                                    <img className="popularimg" src={popular} />
                                  </div>
                                  <div style={{}} className="pricediv">
                                    <div className="titleprice">
                                      <h3> 6 Month </h3>
                                      <h3> 30$ </h3>
                                    </div>

                                    <div className="buttongetstar">
                                      <button> Get Started</button>
                                    </div>

                                    <div className="optPrice">
                                      <div
                                        style={{ marginTop: "38px" }}
                                        className="divco"
                                      >
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>
                                            {" "}
                                            +20,000 TV Channels, Movies & Series
                                          </p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div
                                          style={{ marginBottom: "-21px" }}
                                          className="imgverify"
                                        >
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div
                                          style={{ height: "50px" }}
                                          className="optproduct"
                                        >
                                          {" "}
                                          <p> + 40.000 VOD​</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>
                                            {" "}
                                            FHD, HD & SD Picture Quality
                                          </p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p> All Devices Supported</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>99.9% Server Uptime</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p> Support 24/7​</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>Daily Backups</p>{" "}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <a href="/Checkout/4" className="swiper-slide">
                                  <div className="pricediv">
                                    <div className="titleprice">
                                      <h3> 12 Month </h3>
                                      <h3> 40$ </h3>
                                    </div>

                                    <div className="buttongetstar">
                                      <button> Get Started</button>
                                    </div>

                                    <div className="optPrice">
                                      <div
                                        style={{ marginTop: "38px" }}
                                        className="divco"
                                      >
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>
                                            {" "}
                                            +20,000 TV Channels, Movies & Series
                                          </p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div
                                          style={{ marginBottom: "-21px" }}
                                          className="imgverify"
                                        >
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div
                                          style={{ height: "50px" }}
                                          className="optproduct"
                                        >
                                          {" "}
                                          <p> + 40.000 VOD​</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>
                                            {" "}
                                            FHD, HD & SD Picture Quality
                                          </p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p> All Devices Supported</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>99.9% Server Uptime</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p> Support 24/7​</p>{" "}
                                        </div>
                                      </div>
                                      <div className="divco">
                                        <div className="imgverify">
                                          {" "}
                                          <i
                                            aria-hidden="true"
                                            className="fas fa-check-circle"
                                          ></i>{" "}
                                        </div>
                                        <div className="optproduct">
                                          {" "}
                                          <p>Daily Backups</p>{" "}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className="container">
                            <div className="title_left">
                              <h2 className="title">
                                Get The Best What can <span>IPTV </span>
                                Channels, Movies, Sports, Pay Per View
                              </h2>
                            </div>
                            <div className="textarea_right">
                              <p className="textarea">
                                Enjoy the best IPTV with an Instant auto
                                activation. Works on all Smart Tvs, android &
                                apple devices, PC etc . Our IPTV Includes over
                                +20,000 TV Channels for every country on the
                                planet. Local & premium tv channels included as
                                well as selection of over + 40.000 VOD​. <br />
                                <br />
                                <i
                                  aria-hidden="true"
                                  className="fas fa-check-circle"
                                ></i>{" "}
                                The most important Football competitions <br />
                                <i
                                  aria-hidden="true"
                                  className="fas fa-check-circle"
                                ></i>{" "}
                                The best movies and TV series in the world
                                <br />
                                <i
                                  aria-hidden="true"
                                  className="fas fa-check-circle"
                                ></i>{" "}
                                SD , FULL HD , UHD , 4K
                                <br />
                                <i
                                  aria-hidden="true"
                                  className="fas fa-check-circle"
                                ></i>{" "}
                                The most sensitive sports competitions
                                <br />
                                <i
                                  aria-hidden="true"
                                  className="fas fa-check-circle"
                                ></i>
                                The best wildlife channels
                                <br />
                                <br />
                                <br />
                              </p>
                              <div className="textarea-learn-more freedemo-sks">
                                <a href="/Contactus" className="btn btn-blue">
                                  Contact us To Get a Trial For Test
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    style={{ marginTop: "3px" }}
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M.745.419A.5.5,0,0,0,0,.855v6.29a.5.5,0,0,0,.745.436L6.336,4.436a.5.5,0,0,0,0-.872Z"
                                      transform="translate(9 4)"
                                      fill="#fff"
                                    />
                                    <rect
                                      width="10"
                                      height="2"
                                      rx="0.5"
                                      transform="translate(0 7)"
                                      fill="#fff"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className="container">
                            <div className="title_left">
                              <h2 className="title">
                                Where to buy <span>IPTV </span> subscription ?
                              </h2>
                            </div>
                            <div className="textarea_right">
                              <p className="textarea">
                                Get Channels From All The Countries Around The
                                World! IPTV Shop offers channels from all around
                                the world in one IPTV subscription plan, USA UK
                                Canada Ireland Spain Romania South Africa
                                Thailand Italia Germany France Belgium
                                Luxembourg Netherlands Austria Brazil Bulgaria
                                China Colombia Czech Finland Hungary Iran Israel
                                Japan Macedonia Malaysia Malta Norway Poland
                                Russia Singapore Slovenia Sweden Switzerland
                                Vietnam Albania Portugal Greece India Pakistan
                                Turkish, UAE (Dubai) and many others. <br />
                                <br />
                              </p>
                            </div>
                          </div>
                        </section>
                        <div className="textwidget"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-a137b80 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
              data-id="a137b80"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b8a329"
                  data-id="7b8a329"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-24cfa1f elementor-widget elementor-widget-wp-widget-text"
                      data-id="24cfa1f"
                      data-element_type="widget"
                      data-widget_type="wp-widget-text.default"
                    >
                      <div className="elementor-widget-container">
                        <section className="content-black skew-top skew-bottom home_interactive_map">
                          <div className="skew-top-fix"></div>
                          <div className="container">
                            <div className="interactive-map-intro">
                              <h2>
                                <span>Used by many Operators</span> and Users
                                globally
                              </h2>
                            </div>
                            <div
                              className="map"
                              style={{ textAlign: "center" }}
                            >
                              <noscript>
                                <img src={worldmap} />
                              </noscript>
                              <img
                                className="lazyload"
                                src="data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%20210%20140%22%3E%3C/svg%3E"
                                data-src={worldmap}
                                style={{ height: "143px" }}
                              />
                            </div>
                            <div className="usp-wrapper">
                              <div className="single-usp">
                                <p className="number">52+</p>
                                <p className="description">POINT OF PRESENCE</p>
                              </div>

                              <div className="single-usp">
                                <p className="number">1.3 million</p>
                                <p className="description">Active users</p>
                              </div>

                              <div className="single-usp">
                                <p className="number">25</p>
                                <p className="description">
                                  BANDWIDTH CAPACITY
                                </p>
                              </div>

                              <div className="single-usp">
                                <p className="number">10</p>
                                <p className="description">
                                  YEARS OF EXPERIENCE
                                </p>
                              </div>
                            </div>
                            <div className="testimonials-wrapper">
                              <a href="#" className="single-testimonial">
                                <div className="stars-wrapper">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star checked"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star checked"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star checked"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star checked"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star checked"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                </div>
                                <p className="title">High quality IPTV</p>
                                <p className="comment">
                                  “I can confirm you that the stream is really
                                  awesome and stable. I'm very happy to watch
                                  all my favorite channels.”
                                </p>
                                <div className="company-details">
                                  <p className="name">Mindy R. Coleman</p>
                                  <noscript>
                                    <img
                                      className="company"
                                      src="https://www.tawfikshoot.com/wp-content/uploads/2021/01/ellas-copy-5.svg"
                                    />
                                  </noscript>
                                  <img
                                    className="lazyload company"
                                    src="data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%20210%20140%22%3E%3C/svg%3E"
                                    data-src="https://www.tawfikshoot.com/wp-content/uploads/2021/01/ellas-copy-5.svg"
                                  />
                                </div>
                              </a>

                              <a
                                href="https://google.com"
                                className="single-testimonial"
                              >
                                <div className="stars-wrapper">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star checked"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star checked"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star checked"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star checked"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="star"
                                  >
                                    <rect width="16" height="16" fill="none" />
                                    <path
                                      d="M15.958,6.046a.857.857,0,0,0-.732-.61L10.608,5,8.782.538a.837.837,0,0,0-1.564,0L5.392,5,.773,5.436a.859.859,0,0,0-.731.61.912.912,0,0,0,.249.943l3.491,3.194L2.752,14.915a.907.907,0,0,0,.331.916.816.816,0,0,0,.934.043L8,13.389l3.982,2.484a.818.818,0,0,0,.935-.043.907.907,0,0,0,.331-.916l-1.029-4.731,3.491-3.194a.913.913,0,0,0,.249-.943"
                                      fill="#485fe0"
                                    />
                                  </svg>
                                </div>
                                <p className="title">Amazing seller</p>
                                <p className="comment">
                                  "Amazing seller, Premium IPTV Service and
                                  provide arabic iptv channels and all
                                  documentary and sport iptv channels. Thank
                                  you"
                                </p>
                                <div className="company-details">
                                  <p className="name">Chuck J. Roberts</p>
                                  <noscript>
                                    <img
                                      className="company"
                                      src="https://www.tawfikshoot.com/wp-content/uploads/2021/01/ellas-copy-2.svg"
                                    />
                                  </noscript>
                                  <img
                                    className="lazyload company"
                                    src="data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%20210%20140%22%3E%3C/svg%3E"
                                    data-src="https://www.tawfikshoot.com/wp-content/uploads/2021/01/ellas-copy-2.svg"
                                  />
                                </div>
                              </a>
                            </div>
                            {/* <div className="btwn-wrap">
                                <a href="/cases/" className="btn btn-blue"
                                  >More cases</a
                                >
                              </div> */}
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Home;
